import React from 'react'

const SiteLogo = props => (
	<svg viewBox='0 0 548 484' className='site-logo' {...props}>
		<path d='M510 39C380 26 198 10 96 92 7 164 25 260 36 432c206 43 338 30 414-31 107-86 73-189 60-362zm-18 15l10 94c-146-12-92 254-284 271 180-67 68-298 243-369 0 0 24 2 31 4zM135 85c89-51 207-45 296-37-90 54-93 137-107 185C313 59 82 68 47 220c10-77 42-109 88-135zm133 146c-4-6-17-12-27-10 73 181-180 210-179 32 1-151 241-200 247 8 2 50-29 185-257 156-2-37-7-91-6-125 36 149 261 130 222-61zm172 154c-51 41-154 67-269 50 260 22 192-281 332-269 11 85 6 164-63 219z' />
	</svg>
)
SiteLogo.propTypes = {}
export default SiteLogo
